import React, { useState } from 'react';
import './NavDesktop.css';
import Language from '../../Assets/Images/bandera-españa.png';
import LanguageV from '../../Assets/Images/bandera-valenciano.png';
import { Link } from 'react-router-dom';

export const NavDesktop = (props) => {
    const [activeSubMenu, setActiveSubMenu] = useState(null);
    const [selectedOption, setSelectedOption] = useState(null);

    const onClick = (subMenuId) => {
        setActiveSubMenu(activeSubMenu === subMenuId ? null : subMenuId);
    };

    const handleOptionClick = (option) => {
        if (option === "idioma") {
            const newLanguage = localStorage.getItem("Language") === "Spanish" ? "Valencian" : "Spanish";
            localStorage.setItem("Language", newLanguage);
            window.location.reload();
        }
        setSelectedOption(option === selectedOption ? null : option);
    }

    return (
        <nav className="nav-desktop">
            <ul className="nav-menu">
                <li className="nav-item-top">
                    <span className='nav-link-top' onClick={() => onClick('fallerosSubMenu')}>
                        <Link 
                        to='/login'
                        ><p>{props.I18n.Falleros}</p></Link>
                    </span>
                </li>
                <li className="nav-item-top">
                    <span className='nav-link-top' onClick={() => onClick('historicoSubMenu')}>
                        <p>{props.I18n.Historical}</p>
                    </span>
                    <div className={`sub-menu-desk ${activeSubMenu === 'historicoSubMenu' ? 'open' : ''}`}>
                        <ul>
                            <li>
                                <Link 
                                to="/nuestra-historia"
                                ><p>{props.I18n.OurHistory}</p></Link>
                            </li>
                            <li>
                                <Link 
                                to="/llibret"
                                ><p>{props.I18n.Llibret}</p></Link>
                            </li>
                            <li>
                                <Link 
                                to='/representantes-anteriores'
                                ><p>{props.I18n.PreviousRepresentatives}</p></Link>
                            </li>
                        </ul>
                    </div>
                </li>
                <li className="nav-item-top">
                    <span className='nav-link-top' onClick={() => onClick('galeriaSubMenu')}>
                        <p>{props.I18n.Galery}</p>
                    </span>
                    <div className={`sub-menu-desk ${activeSubMenu === 'galeriaSubMenu' ? 'open' : ''}`}>
                        <ul>
                            <li>
                                <Link 
                                to='/arte-fallero'
                                ><p>{props.I18n.FalleroArt}</p></Link>
                            </li>
                            <li>
                                <Link 
                                to='/premios-y-reconocimientos'
                                ><p>{props.I18n.AwardsAndHonours}</p></Link>
                            </li>
                        </ul>
                    </div>
                </li>
                <li className="nav-item-top">
                    <span className='nav-link-top' onClick={() => onClick('ejercicioSubMenu')}>
                        <p>{props.I18n.Exercise}</p>
                    </span>
                    <div className={`sub-menu-desk ${activeSubMenu === 'ejercicioSubMenu' ? 'open' : ''}`}>
                        <ul>
                            <li>
                                <Link 
                                 to='/representantes-actuales'
                                 ><p>{props.I18n.CurrentRepresentatives}</p></Link>
                            </li>
                            <li>
                                <Link 
                                to='/noticias'
                                ><p>{props.I18n.News}</p></Link>
                            </li>
                            <li>
                                <Link 
                                to='/calendario-rodrigo'
                                ><p>{props.I18n.EventsCalendar}</p></Link>
                            </li>
                        </ul>
                    </div>
                </li>
                <li className="nav-item-top">
                    <span className='nav-link-top' onClick={() => onClick('nosotrosSubMenu')}>
                        <p>{props.I18n.Us}</p>
                    </span>
                    <div className={`sub-menu-desk ${activeSubMenu === 'nosotrosSubMenu' ? 'open' : ''}`}>
                        <ul>
                            <li>
                                <Link 
                                 to='/formulario-de-contacto'
                                 ><p>{props.I18n.ContactForm}</p></Link>
                            </li>
                            <li>
                                <Link 
                                to='/patrocinadores'
                                ><p>{props.I18n.Sponsors}</p></Link>
                            </li>
                            <li>
                                <Link 
                                 to='/descargas'
                                ><p>{props.I18n.Downloads}</p></Link>
                            </li>
                            <li>
                                <Link
                                to='/canciones-rodrigueras'
                                ><p>{props.I18n.RodriguerasSongs}</p></Link>
                            </li>
                        </ul>
                    </div>
                </li>
                <li className={`nav-item-top ${selectedOption === 'idioma' ? 'selected' : ''}`}>
                    <span className='nav-link-top' onClick={() => handleOptionClick('idioma')}>
                        {localStorage.getItem("Language") === "Spanish" ? <img src={Language} alt='Language' /> : <img src={LanguageV} alt='Language' />}
                    </span>
                </li>
            </ul>
        </nav>
    );
};
